module.exports = __webpack_public_path__ + "static/IMG_0085-scaled-3b98c1a5fc854b1bbf8e86a6de6dca1a.jpg";